var map = {
	"./icon_collect.png": "20d7",
	"./icon_coupon.png": "9745",
	"./icon_express_arrow.png": "d9eb",
	"./icon_gift.png": "051f",
	"./icon_group.png": "a289",
	"./icon_list_about.png": "b8fa",
	"./icon_list_feedback.png": "d5b3",
	"./icon_list_message.png": "5749",
	"./icon_list_question.png": "9f55",
	"./icon_list_remind.png": "cd4d",
	"./icon_list_setting.png": "2048",
	"./icon_order.png": "d2fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfad";